import { Component, inject, OnDestroy, AfterViewInit, AfterViewChecked, Input, SimpleChanges, NO_ERRORS_SCHEMA } from '@angular/core';
import { IconsService } from '../../../services/icons.service';
import { aplicacion, DataCore } from '../../../interface/data-core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { ResizeUtils } from './utilsResize';
import { RemoveAccentsPipe } from '../../../pipe/remove-accents.pipe';
import { FormsModule } from '@angular/forms';
import { openUrl } from '../../../utils/generales';

@Component({
    selector: 'app-actividades-filtradas',
    imports: [FormsModule, CommonModule, PaginatorModule, RemoveAccentsPipe],
    templateUrl: './actividades-filtradas.component.html',
    styleUrl: './actividades-filtradas.component.css',
    schemas: [NO_ERRORS_SCHEMA]
})
export class ActividadesFiltradasComponent implements OnDestroy, AfterViewInit {
    @Input() public dataAplicaciones: aplicacion[] = [];

    public _icon = inject(IconsService);
    public listAplicaciones: aplicacion[] = [];
    public paginadoListAplicaciones: aplicacion[] = [];
    public url_img_app: string = environment.url_img_app;

    public first: number = 0;
    public rows: number = 0;
    public totalRecords: number = 0;

    // Utilidad para el resize
    private resizeUtils: ResizeUtils;
    imgLoading: any;

    public searchTerm: string = '';

    private readonly url_app: string = environment.url_get_app;
    constructor() {
        this.resizeUtils = new ResizeUtils((columns: number, rows: number, totalApps: number) => {
            // Solo actualizar si hay un cambio significativo y los valores son razonables
            const oldRows = this.rows;
            this.rows = totalApps;
            this.first = 0; // Reiniciar a la primera página
            this.paginadoListAplicaciones = this.listAplicaciones.slice(this.first, this.first + this.rows);
            //console.debug(`Paginación actualizada: ${oldRows} → ${this.rows} elementos por página`);
            //console.debug(`Mostrando elementos del ${this.first} al ${this.first + this.rows - 1}`);
        });
    }

    ngAfterViewInit() {
        this.listAplicaciones = [...(this.dataAplicaciones ?? [])];
        this.totalRecords = this.listAplicaciones.length;

        //console.debug('Actividades Filtradas Component Initialized', this.listAplicaciones);

        this.resizeUtils.setupResizeListener();

        // Aseguramos que el layout esté 100% listo
        setTimeout(() => {
            requestAnimationFrame(() => {
                if (this.listAplicaciones.length > 0) {
                    this.resizeUtils.getColumnsInfo();
                }
            });
        }, 0);
    }

    ngOnDestroy() {
        // Remover el listener de resize al destruir el componente
        this.resizeUtils.destroy();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.listAplicaciones = [...(this.dataAplicaciones ?? [])];
        this.totalRecords = this.listAplicaciones.length;
        if (this.listAplicaciones.length > 0) {
            this.resizeUtils.getColumnsInfo();
        }
    }

    onPageChange(event: PaginatorState) {
        this.first = event.first ?? 0;
        this.rows = event.rows ?? 0;
        this.paginadoListAplicaciones = this.listAplicaciones.slice(this.first, this.first + this.rows);
    }

    showApplication(actividad: aplicacion): void {
        // Aquí puedes implementar la lógica para mostrar la aplicación seleccionada
        //console.debug('Aplicación seleccionada:', actividad);
    }

    onSearch() {
        // Lógica para manejar la búsqueda
        if (this.searchTerm.trim() === '') {
            this.listAplicaciones = [...(this.dataAplicaciones ?? [])];
        } else {
            this.listAplicaciones = this.dataAplicaciones.filter(app =>
                app.n.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                app.p.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
                app.pc?.toLowerCase().includes(this.searchTerm.toLowerCase())
            );

            //eliminar registros duplicados
            this.listAplicaciones = this.listAplicaciones.filter((app, index, self) =>
                index === self.findIndex((t) => (
                    t.i === app.i
                ))
            );
        }

        this.totalRecords = this.listAplicaciones.length;
        if (this.listAplicaciones.length > 0) {
            this.resizeUtils.getColumnsInfo();
        }
    }

    onOpenApp(actividad: aplicacion): void {
        openUrl(`${this.url_app}${actividad.i}`);
    }

    showShareButton(index: number, actividad: aplicacion) {
        const container = document.getElementById(`gshare-${index}`);
        if (container) {
            container.innerHTML = `<g:sharetoclassroom url="${this.getGoogleShareUrl(actividad)}" size="30" theme="classic" itemtype="assignment"></g:sharetoclassroom>`;
            (window as any).gapi?.sharetoclassroom?.go();
        }
    }

    hideShareButton(index: number) {
        const container = document.getElementById(`gshare-${index}`);
        if (container) {
            container.innerHTML = '';
        }
    }

    private getGoogleShareUrl(actividad: aplicacion) {
        return `${this.url_app}${actividad.i}`;
    }
}

